import '../../../Pandora/model/object';

import AdvanceSearchPreprocessor from './preprocessors/AdvanceSearchPreprocessor';
import ColumnSearchPreprocessor from './preprocessors/ColumnSearchPreprocessor';
import PagingPreprocessor from './preprocessors/PagingPreprocessor';
import SearchPreprocessor from './preprocessors/SearchPreprocessor';
import SortingPreprocessor from './preprocessors/SortingPreprocessor';

import BaseRequesterClassFactory from './requests/BaseQueryRequester';
import ClientDataRequesterClassFactory from './requests/ClientDataRequester';
import DataDefinitionRequesterFactory from './requests/DataDefinitionRequester';
import { RelationsRequesterFactory } from './requests/RelationsRequester';
import DataDefinitionQueryOptionsFactory from './requests/DataDefinitionRequestOptions';
import MultiFragmentRequesterClassFactory from './requests/MultiFragmentRequester';
import ServiceRequesterClassFactory from './requests/ServiceRequester';

import DataQueryColumnFactory from './DataQueryColumn';
import DataQueryDefinitionFactory from './DataQueryDefinition';
import DataQueryEnums from './DataQueryEnumerations';
import DataQueryExecutorFactory from './DataQueryExecutor';
import DataQueryRowClassFactory from './DataQueryRow';

import { MxGridColumnFiltersFactory } from './column-filters/mx-grid-column-filters-factory';
import { MxFilterOperatorsFactory } from './column-filters/mx-grid-column-filter-operators-factory';

function createClassFactory(ClassName) {
	classFactory.$inject = ['$injector'];
	function classFactory($injector) {
		return (options) => $injector.instantiate(ClassName, options);
	}

	return classFactory;
}

export default angular
	.module('mx.sb.Agent.DataQuery', [])
	.value('mx.sb.Agent.DataQuery.Enums', DataQueryEnums)

	.factory('mx.sb.Agent.DataQuery.AdvanceSearchPreprocessor', createClassFactory(AdvanceSearchPreprocessor))
	.factory('mx.sb.Agent.DataQuery.ColumnSearchPreprocessor', createClassFactory(ColumnSearchPreprocessor))
	.factory('mx.sb.Agent.DataQuery.PagingPreprocessor', createClassFactory(PagingPreprocessor))
	.factory('mx.sb.Agent.DataQuery.SearchPreprocessor', createClassFactory(SearchPreprocessor))
	.factory('mx.sb.Agent.DataQuery.SortingPreprocessor', createClassFactory(SortingPreprocessor))

	.factory('mx.sb.Agent.DataQuery.BaseRequester', BaseRequesterClassFactory)
	.factory('mx.sb.Agent.DataQuery.ClientDataRequester', ClientDataRequesterClassFactory)
	.factory('mx.sb.Agent.DataQuery.DataDefinitionRequester', DataDefinitionRequesterFactory)
	.factory('mx.sb.Agent.DataQuery.RelationsRequester', RelationsRequesterFactory)
	.factory('mx.sb.Agent.DataQuery.DataDefinitionRequestOptions', DataDefinitionQueryOptionsFactory)
	.factory('mx.sb.Agent.DataQuery.MultiFragmentRequester', MultiFragmentRequesterClassFactory)
	.factory('mx.sb.Agent.DataQuery.ServiceRequester', ServiceRequesterClassFactory)

	.factory('mx.sb.Agent.DataQuery.Column', DataQueryColumnFactory)
	.factory('mx.sb.Agent.DataQuery.DataQueryDefinition', DataQueryDefinitionFactory)
	.factory('mx.sb.Agent.DataQuery.Executor', DataQueryExecutorFactory)

	.service('mx.sb.Agent.DataQuery.ColumnFiltersFactory', MxGridColumnFiltersFactory)
	.factory('mx.sb.Agent.DataQuery.FilterOperatorsFactory', MxFilterOperatorsFactory)

	.factory('mx.sb.Agent.DataQuery.Row', DataQueryRowClassFactory).name;
